import React from 'react';
import styled, { css } from 'styled-components';
import SmBg from '../assets/bg-sm.jpg';
import LgBg from '../assets/bg-lg.jpg';

interface WrapProps {}
const StyledWrap = styled.div<WrapProps>`
    ${({ theme }) => css`
        display: grid;
        place-items: center;
        grid-template-rows: 1fr;
        min-height: ${theme.appHeight.lg};
        width: 100%;
        position: relative;
        flex-grow: 1;

        padding: 48px 16px;

        img {
            z-index: -1;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            object-fit: cover;
            width: 100%;
            height: 100%;
        }
    `}
`;
const Landing = ({ children }) => (
    <StyledWrap>
        {children}
        <picture>
            <source srcSet={LgBg} media="(min-width: 768px)" />
            <img src={SmBg} alt="Gardens" />
        </picture>
    </StyledWrap>
);

export default Landing;
